import { ca } from '@cian/analytics';

export const trackBookingClick = (label: string) => {
  ca('eventSite', {
    action: 'click_booking',
    category: 'booking',
    name: 'oldevent',
    label,
    useLastProducts: true,
  });
};
